import { ApplicationRef, Injectable, NgZone } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

/**
 * Angular 22 defaults new components to OnPush. Many screens update state inside
 * HttpClient subscribe callbacks without markForCheck/detectChanges, so the view
 * stays stale until a tab click or navigation triggers another CD cycle.
 * This interceptor schedules a CD pass after every HTTP request completes.
 */
@Injectable()
export class ChangeDetectionInterceptor implements HttpInterceptor {
  constructor(
    private readonly appRef: ApplicationRef,
    private readonly ngZone: NgZone
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      finalize(() => {
        this.ngZone.run(() => {
          // Defer one microtask so component subscribe() callbacks finish first.
          Promise.resolve().then(() => this.appRef.tick());
        });
      })
    );
  }
}
